function IconFilter({ height = 24, ...remain }: any) {
  return (
    <svg
      width={height}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...remain}
    >
      <path
        d="M10.3319 16.5929H4.03009"
        stroke="black"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.1428 6.90037H19.4446"
        stroke="black"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.72778 6.84625C8.72778 5.5506 7.66943 4.5 6.36422 4.5C5.05902 4.5 4.00067 5.5506 4.00067 6.84625C4.00067 8.14191 5.05902 9.19251 6.36422 9.19251C7.66943 9.19251 8.72778 8.14191 8.72778 6.84625Z"
        stroke="black"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M20.0035 16.5537C20.0035 15.2581 18.9459 14.2075 17.6407 14.2075C16.3347 14.2075 15.2764 15.2581 15.2764 16.5537C15.2764 17.8494 16.3347 18.9 17.6407 18.9C18.9459 18.9 20.0035 17.8494 20.0035 16.5537Z"
        stroke="black"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export default IconFilter;
